var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("section", { attrs: { id: "content" } }, [
        _c("div", { staticClass: "container" }, [
          _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "col-md-9", attrs: { id: "main" } }, [
              _c("div", { staticClass: "container shortcode travel-ideas" }, [
                _c("h1", { staticClass: "idea-title" }, [
                  _vm._m(0),
                  _vm._v(_vm._s(_vm.titleinfo[_vm.getCurrentLocale])),
                ]),
              ]),
              _vm._v(" "),
              _c("br"),
              _vm._v(" "),
              _c("div", { staticClass: "booking-information sdr-box" }, [
                _c("h4", {
                  domProps: {
                    innerHTML: _vm._s(
                      _vm.prohibited_h4_1[_vm.getCurrentLocale]
                    ),
                  },
                }),
                _vm._v(" "),
                _c("h5", {
                  domProps: {
                    innerHTML: _vm._s(
                      _vm.prohibited_h5_1[_vm.getCurrentLocale]
                    ),
                  },
                }),
                _vm._v(" "),
                _c("br"),
                _c("p", {
                  domProps: {
                    innerHTML: _vm._s(_vm.prohibited_p_1[_vm.getCurrentLocale]),
                  },
                }),
                _vm._v(" "),
                _c(
                  "ul",
                  {
                    staticClass: "check-circle box",
                    staticStyle: {
                      "margin-bottom": "10px",
                      "margin-left": "15px",
                    },
                  },
                  [
                    _c("li", {
                      domProps: {
                        innerHTML: _vm._s(
                          _vm.prohibited_li_1[_vm.getCurrentLocale]
                        ),
                      },
                    }),
                    _vm._v(" "),
                    _c("li", {
                      domProps: {
                        innerHTML: _vm._s(
                          _vm.prohibited_li_2[_vm.getCurrentLocale]
                        ),
                      },
                    }),
                    _vm._v(" "),
                    _c("li", {
                      domProps: {
                        innerHTML: _vm._s(
                          _vm.prohibited_li_3[_vm.getCurrentLocale]
                        ),
                      },
                    }),
                    _vm._v(" "),
                    _c("li", {
                      domProps: {
                        innerHTML: _vm._s(
                          _vm.prohibited_li_4[_vm.getCurrentLocale]
                        ),
                      },
                    }),
                    _vm._v(" "),
                    _c("li", {
                      domProps: {
                        innerHTML: _vm._s(
                          _vm.prohibited_li_5[_vm.getCurrentLocale]
                        ),
                      },
                    }),
                    _vm._v(" "),
                    _c("li", {
                      domProps: {
                        innerHTML: _vm._s(
                          _vm.prohibited_li_6[_vm.getCurrentLocale]
                        ),
                      },
                    }),
                    _vm._v(" "),
                    _c("li", {
                      domProps: {
                        innerHTML: _vm._s(
                          _vm.prohibited_li_7[_vm.getCurrentLocale]
                        ),
                      },
                    }),
                  ]
                ),
                _vm._v(" "),
                _c("br"),
                _c("br"),
                _c("br"),
                _c("h4", {
                  domProps: {
                    innerHTML: _vm._s(
                      _vm.prohibited_h4_2[_vm.getCurrentLocale]
                    ),
                  },
                }),
                _vm._v(" "),
                _c("h5", {
                  domProps: {
                    innerHTML: _vm._s(
                      _vm.prohibited_h5_2[_vm.getCurrentLocale]
                    ),
                  },
                }),
                _vm._v(" "),
                _c("p", {
                  domProps: {
                    innerHTML: _vm._s(_vm.prohibited_p_2[_vm.getCurrentLocale]),
                  },
                }),
                _vm._v(" "),
                _c("p", {
                  domProps: {
                    innerHTML: _vm._s(_vm.prohibited_p_3[_vm.getCurrentLocale]),
                  },
                }),
                _vm._v(" "),
                _c(
                  "ul",
                  {
                    staticClass: "check-circle box",
                    staticStyle: {
                      "margin-bottom": "10px",
                      "margin-left": "15px",
                    },
                  },
                  [
                    _c("li", {
                      domProps: {
                        innerHTML: _vm._s(
                          _vm.prohibited_li_8[_vm.getCurrentLocale]
                        ),
                      },
                    }),
                    _vm._v(" "),
                    _c("li", {
                      domProps: {
                        innerHTML: _vm._s(
                          _vm.prohibited_li_9[_vm.getCurrentLocale]
                        ),
                      },
                    }),
                    _vm._v(" "),
                    _c("li", {
                      domProps: {
                        innerHTML: _vm._s(
                          _vm.prohibited_li_10[_vm.getCurrentLocale]
                        ),
                      },
                    }),
                    _vm._v(" "),
                    _c("li", {
                      domProps: {
                        innerHTML: _vm._s(
                          _vm.prohibited_li_11[_vm.getCurrentLocale]
                        ),
                      },
                    }),
                    _vm._v(" "),
                    _c("li", {
                      domProps: {
                        innerHTML: _vm._s(
                          _vm.prohibited_li_12[_vm.getCurrentLocale]
                        ),
                      },
                    }),
                    _vm._v(" "),
                    _c("li", {
                      domProps: {
                        innerHTML: _vm._s(
                          _vm.prohibited_li_13[_vm.getCurrentLocale]
                        ),
                      },
                    }),
                    _vm._v(" "),
                    _c("li", {
                      domProps: {
                        innerHTML: _vm._s(
                          _vm.prohibited_li_14[_vm.getCurrentLocale]
                        ),
                      },
                    }),
                    _vm._v(" "),
                    _c("li", {
                      domProps: {
                        innerHTML: _vm._s(
                          _vm.prohibited_li_15[_vm.getCurrentLocale]
                        ),
                      },
                    }),
                  ]
                ),
                _vm._v(" "),
                _c("br"),
                _c("br"),
                _c("p", {
                  domProps: {
                    innerHTML: _vm._s(_vm.prohibited_p_4[_vm.getCurrentLocale]),
                  },
                }),
                _vm._v(" "),
                _c(
                  "ul",
                  {
                    staticClass: "check-circle box",
                    staticStyle: {
                      "margin-bottom": "10px",
                      "margin-left": "15px",
                    },
                  },
                  [
                    _c("li", {
                      domProps: {
                        innerHTML: _vm._s(
                          _vm.prohibited_li_16[_vm.getCurrentLocale]
                        ),
                      },
                    }),
                    _vm._v(" "),
                    _c("li", {
                      domProps: {
                        innerHTML: _vm._s(
                          _vm.prohibited_li_17[_vm.getCurrentLocale]
                        ),
                      },
                    }),
                    _vm._v(" "),
                    _c("li", {
                      domProps: {
                        innerHTML: _vm._s(
                          _vm.prohibited_li_18[_vm.getCurrentLocale]
                        ),
                      },
                    }),
                  ]
                ),
                _vm._v(" "),
                _c("br"),
                _c("br"),
                _c("p", {
                  domProps: {
                    innerHTML: _vm._s(_vm.prohibited_p_5[_vm.getCurrentLocale]),
                  },
                }),
                _vm._v(" "),
                _c(
                  "ul",
                  {
                    staticClass: "check-circle box",
                    staticStyle: {
                      "margin-bottom": "10px",
                      "margin-left": "15px",
                    },
                  },
                  [
                    _c("li", {
                      domProps: {
                        innerHTML: _vm._s(
                          _vm.prohibited_li_19[_vm.getCurrentLocale]
                        ),
                      },
                    }),
                    _vm._v(" "),
                    _c("li", {
                      domProps: {
                        innerHTML: _vm._s(
                          _vm.prohibited_li_20[_vm.getCurrentLocale]
                        ),
                      },
                    }),
                    _vm._v(" "),
                    _c("li", {
                      domProps: {
                        innerHTML: _vm._s(
                          _vm.prohibited_li_21[_vm.getCurrentLocale]
                        ),
                      },
                    }),
                    _vm._v(" "),
                    _c("li", {
                      domProps: {
                        innerHTML: _vm._s(
                          _vm.prohibited_li_22[_vm.getCurrentLocale]
                        ),
                      },
                    }),
                    _vm._v(" "),
                    _c("li", {
                      domProps: {
                        innerHTML: _vm._s(
                          _vm.prohibited_li_23[_vm.getCurrentLocale]
                        ),
                      },
                    }),
                    _vm._v(" "),
                    _c("li", {
                      domProps: {
                        innerHTML: _vm._s(
                          _vm.prohibited_li_24[_vm.getCurrentLocale]
                        ),
                      },
                    }),
                    _vm._v(" "),
                    _c("li", {
                      domProps: {
                        innerHTML: _vm._s(
                          _vm.prohibited_li_25[_vm.getCurrentLocale]
                        ),
                      },
                    }),
                    _vm._v(" "),
                    _c("li", {
                      domProps: {
                        innerHTML: _vm._s(
                          _vm.prohibited_li_26[_vm.getCurrentLocale]
                        ),
                      },
                    }),
                  ]
                ),
                _vm._v(" "),
                _c("br"),
                _c("br"),
                _c("p", {
                  domProps: {
                    innerHTML: _vm._s(_vm.prohibited_p_6[_vm.getCurrentLocale]),
                  },
                }),
                _vm._v(" "),
                _c(
                  "ul",
                  {
                    staticClass: "check-circle box",
                    staticStyle: {
                      "margin-bottom": "10px",
                      "margin-left": "15px",
                    },
                  },
                  [
                    _c("li", {
                      domProps: {
                        innerHTML: _vm._s(
                          _vm.prohibited_li_27[_vm.getCurrentLocale]
                        ),
                      },
                    }),
                    _vm._v(" "),
                    _c("li", {
                      domProps: {
                        innerHTML: _vm._s(
                          _vm.prohibited_li_28[_vm.getCurrentLocale]
                        ),
                      },
                    }),
                    _vm._v(" "),
                    _c("li", {
                      domProps: {
                        innerHTML: _vm._s(
                          _vm.prohibited_li_29[_vm.getCurrentLocale]
                        ),
                      },
                    }),
                    _vm._v(" "),
                    _c("li", {
                      domProps: {
                        innerHTML: _vm._s(
                          _vm.prohibited_li_30[_vm.getCurrentLocale]
                        ),
                      },
                    }),
                    _vm._v(" "),
                    _c("li", {
                      domProps: {
                        innerHTML: _vm._s(
                          _vm.prohibited_li_31[_vm.getCurrentLocale]
                        ),
                      },
                    }),
                    _vm._v(" "),
                    _c("li", {
                      domProps: {
                        innerHTML: _vm._s(
                          _vm.prohibited_li_32[_vm.getCurrentLocale]
                        ),
                      },
                    }),
                  ]
                ),
                _vm._v(" "),
                _c("br"),
                _c("br"),
                _c("p", {
                  domProps: {
                    innerHTML: _vm._s(_vm.prohibited_p_7[_vm.getCurrentLocale]),
                  },
                }),
                _vm._v(" "),
                _c(
                  "ul",
                  {
                    staticClass: "check-circle box",
                    staticStyle: {
                      "margin-bottom": "10px",
                      "margin-left": "15px",
                    },
                  },
                  [
                    _c("li", {
                      domProps: {
                        innerHTML: _vm._s(
                          _vm.prohibited_li_33[_vm.getCurrentLocale]
                        ),
                      },
                    }),
                    _vm._v(" "),
                    _c("li", {
                      domProps: {
                        innerHTML: _vm._s(
                          _vm.prohibited_li_34[_vm.getCurrentLocale]
                        ),
                      },
                    }),
                    _vm._v(" "),
                    _c("li", {
                      domProps: {
                        innerHTML: _vm._s(
                          _vm.prohibited_li_35[_vm.getCurrentLocale]
                        ),
                      },
                    }),
                  ]
                ),
                _vm._v(" "),
                _c("br"),
                _c("br"),
                _c("p", {
                  domProps: {
                    innerHTML: _vm._s(_vm.prohibited_p_8[_vm.getCurrentLocale]),
                  },
                }),
                _vm._v(" "),
                _c(
                  "ul",
                  {
                    staticClass: "check-circle box",
                    staticStyle: {
                      "margin-bottom": "10px",
                      "margin-left": "15px",
                    },
                  },
                  [
                    _c("li", {
                      domProps: {
                        innerHTML: _vm._s(
                          _vm.prohibited_li_36[_vm.getCurrentLocale]
                        ),
                      },
                    }),
                    _vm._v(" "),
                    _c("li", {
                      domProps: {
                        innerHTML: _vm._s(
                          _vm.prohibited_li_37[_vm.getCurrentLocale]
                        ),
                      },
                    }),
                    _vm._v(" "),
                    _c("li", {
                      domProps: {
                        innerHTML: _vm._s(
                          _vm.prohibited_li_38[_vm.getCurrentLocale]
                        ),
                      },
                    }),
                    _vm._v(" "),
                    _c("li", {
                      domProps: {
                        innerHTML: _vm._s(
                          _vm.prohibited_li_39[_vm.getCurrentLocale]
                        ),
                      },
                    }),
                    _vm._v(" "),
                    _c("li", {
                      domProps: {
                        innerHTML: _vm._s(
                          _vm.prohibited_li_40[_vm.getCurrentLocale]
                        ),
                      },
                    }),
                    _vm._v(" "),
                    _c("li", {
                      domProps: {
                        innerHTML: _vm._s(
                          _vm.prohibited_li_41[_vm.getCurrentLocale]
                        ),
                      },
                    }),
                    _vm._v(" "),
                    _c("li", {
                      domProps: {
                        innerHTML: _vm._s(
                          _vm.prohibited_li_42[_vm.getCurrentLocale]
                        ),
                      },
                    }),
                    _vm._v(" "),
                    _c("li", {
                      domProps: {
                        innerHTML: _vm._s(
                          _vm.prohibited_li_43[_vm.getCurrentLocale]
                        ),
                      },
                    }),
                  ]
                ),
              ]),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "sidebar col-md-3" },
              [_c("sdr-aboutsundair-box"), _vm._v(" "), _c("sdr-contact-box")],
              1
            ),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c("sdr-promobox"),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "index" }, [
      _c("i", { staticClass: "soap-icon-star circle" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }